/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListContactRequestJobsQueryResponse,
  ListContactRequestJobsQueryParams,
} from '../../types/ListContactRequestJobs'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listContactRequestJobs } from '../../clients/listContactRequestJobs'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listContactRequestJobsQueryKey = (
  params?: ListContactRequestJobsQueryParams
) => [{ url: '/api/v1/contact_request/' }, ...(params ? [params] : [])] as const

export type ListContactRequestJobsQueryKey = ReturnType<
  typeof listContactRequestJobsQueryKey
>

export function listContactRequestJobsQueryOptions(
  params?: ListContactRequestJobsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listContactRequestJobsQueryKey(params)
  return queryOptions<
    ListContactRequestJobsQueryResponse,
    ResponseErrorConfig<Error>,
    ListContactRequestJobsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listContactRequestJobs(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary List contact request jobs (paginated)
 * {@link /api/v1/contact_request/}
 */
export function useListContactRequestJobs<
  TData = ListContactRequestJobsQueryResponse,
  TQueryData = ListContactRequestJobsQueryResponse,
  TQueryKey extends QueryKey = ListContactRequestJobsQueryKey,
>(
  params?: ListContactRequestJobsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListContactRequestJobsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? listContactRequestJobsQueryKey(params)

  const query = useQuery(
    {
      ...listContactRequestJobsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
